// QR Menü Gün Sonu İşlemi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrDailyClosing';

export const qrDailyClosingGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'QR menü gün sonu nasıl alınır?'),
  intro: t(`${G}.intro`, 'Bu pencere, son gün sonundan bu yana şubede alınan QR menü siparişlerinin tutarını seçtiğiniz banka hesabına aktarır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve şube'),
    body: t(`${G}.regions.body`, 'Özet, hesap ve not'),
    footer: t(`${G}.regions.footer`, 'Gün Sonu Al'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Gün Sonu Özeti'),
      text: t(`${G}.s1.text`, 'Dönem, bu şubede yapılan son gün sonundan bugüne kadardır; hiç gün sonu alınmadıysa "Başlangıç"tan itibaren hesaplanır. Toplam sipariş, tamamlanan (teslim edilen) ve iptal edilen sipariş sayıları ile toplam ciro gösterilir.'),
      tips: [
        t(`${G}.s1.tip1`, '"Aktarılacak Tutar", dönemdeki TÜM siparişlerin toplamıdır; sipariş durumu (açık, iptal vb.) fark etmez. İptal edilen siparişler varsa tutarı kontrol edin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef banka hesabını seçin'),
      text: t(`${G}.s2.text`, '"Banka Seçin" listesinden hesabı, varsa "Alt Hesap (Opsiyonel)" alanından alt hesabı seçin; boş bırakılırsa ana hesap kullanılır. Altta mevcut bakiye ve "İşlem Sonrası Bakiye" görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Not ekleyin (isteğe bağlı)'),
      text: t(`${G}.s3.text`, '"Gün Sonu Notları" alanına kasa farkı gibi açıklamaları yazabilirsiniz; not gün sonu kaydına eklenir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Gün Sonu Al'),
      text: t(`${G}.s4.text`, '"Gün Sonu Al" önce bir gün sonu kaydı oluşturur, sonra aktarılacak tutarı seçilen banka hesabına para girişi olarak ekler (hesap bakiyesi artar, "… şubesi gün sonu transferi" açıklamalı hareket oluşur). Yeni dönem bu andan itibaren başlar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Aktarılacak tutar sıfırsa veya hesap seçilmemişse düğme pasif kalır.'),
        t(`${G}.s4.tip2`, 'Bu pencerede geri alma yoktur. Yanlış aktarımı düzeltmek için banka hesabı hareketlerini kontrol edin.'),
      ],
    },
  ],
});
